<div echarts [options]="options" class="field-use-area-chart"></div>
